import { IntroductionTags } from '../IntroductionTags';
import styles from './IntroductionMainContent.module.css';

type IntroductionMainContentProps = {
  title: string;
  paragraphs: string[];
  tags: { heading: string; items: string[] }[];
};

export const IntroductionMainContent = ({ title, paragraphs, tags }: IntroductionMainContentProps) => {
  return (
    <div className={styles.mainContentRoot}>
      <h2 className={styles.mainContentTitle}>{title}</h2>
      <div className={styles.mainContentParagraphsLayout}>
        {paragraphs.map((paragraph, index) => (
          <p key={index} className={styles.mainContentParagraph}>
            {paragraph}
          </p>
        ))}
      </div>
      <IntroductionTags tags={tags} />
    </div>
  );
};
